<template>
  <div class="get-read">
    <image-list :imageList="imgList"></image-list>

    <div class="get-read-btn" v-if="hideBtn">
      <div class="get-read-btn-content" v-if="!isGet" @click="get">
        <span>99元/年</span> · 限时免费订阅
      </div>
      <div class="get-read-btn-content grey" v-if="isGet">
        已订阅
      </div>
    </div>

    <div class="get-read-notice" @click="getFinish=false" v-show="getFinish">
      <div class="notice-content" @click.stop>
        <img class="notice-content-icon" src="../assets/icons/getread-icon-paper.png" alt="">
        <h1 class="notice-content-title">订阅成功</h1>
        <p class="notice-content-desc">今日早点已送到哦，明日开始早6:30推送内容
          <br />每日更新，记得尽情的享用哦~</p>
        <div class="notice-content-remind">请务必关注微课微信公众号</div>
        <div class="notice-content-bottom">
          <h5>获取为您量身定制的职场早点哦</h5>
          <img src="http://edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/qrcode/fd817da2c074bc30ea560036e5f2c050.png" alt="">
          <p>陪伴阅读·让你变得更好</p>
        </div>
      </div>
    </div>

    <div class="get-read-err" v-if="isErr">
      <p v-if="isGet">已订阅, 请勿重复订阅</p>
      <div v-else>
        <img src="../assets/icons/getread-no-wifi.png" alt="">
        <p>网络状况不佳
          <br />请刷新后再试哦~</p>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@edu-fe/api'
  import ImageList from '../components/ImageList.vue'
  import login from '@edu-fe/login'
import { setTimeout } from 'timers';

  export default {

    data() {
      return {
        isGet: false,
        getFinish: false,
        isErr: false,
        hideBtn: false,
        imgList: [
          require("../assets/images/getread/mor-read_01.jpg"),
          require("../assets/images/getread/mor-read_02.jpg"),
          require("../assets/images/getread/mor-read_03.jpg"),
          require("../assets/images/getread/mor-read_04.jpg"),
          require("../assets/images/getread/mor-read_05.jpg"),
        ]
      }
    },
    components: { ImageList },
    created() {
      this.init()
    },
    methods: {

      async get() {
        const wpsSid = await login.getWpsSid()
        const from = this.$route.query.from?this.$route.query.from:''
        if (wpsSid) {
          try {
            const res = await api.getRead.get(from)()
            if (res.data === 'success') {
              this.getFinish = true
              this.isGet = true
            } else {
              this.showErr()
            }
          } catch (error) {
            this.showErr()
          }
        } else {
          login.login()
        }

      },
      showErr() {
        this.isErr = true;
        setTimeout(() => {
          this.isErr = false;
        }, 3000);
      },

      async init() {
        setTimeout(()=>{
          this.hideBtn = true
        }, 300)
        this.isGet = await api.getRead.getState().then(res=>{
          return res.data === 1
        })
      }
    },


  }
</script>

<style lang="scss" scope>
  @charset "UTF-8";
  @import "../style/main";
  .get-read {
    position: relative;
    width: 100%;
    padding-bottom: use(110);
    &-btn {
      width: 100%;
      height: use(110);
      position: fixed;
      left: 0;
      bottom: 0;
      background-color: #fff;
      text-align: center;
      &-content {
        background-image: linear-gradient(135deg, #FFB500 0%, #F48F00 100%);
        border-radius: use(100);
        width: 88%;
        font-size: use(36);
        line-height: use(80);
        color: #FFFFFF;
        // letter-spacing: use(10);
        margin: use(15) auto;
        font-weight: bold;
        > span {
          color: #BD7200;
          text-decoration: line-through;
        }
      }
    }
    &-notice {
      width: 100%;
      height: 100vh;
      text-align: center;
      position: fixed;
      left: 0;
      top: 0;
      background-color: rgba(#000, 0.5);
      z-index: 9999;
      .notice {
        &-content {
          width: 74%;
          margin: 15vh auto 0;
          background-color: #fff;
          border-radius: use(8);
          position: relative;
          padding-top: use(74);
          &-icon {
            width: use(165);
            position: absolute;
            left: 50%;
            top: use(-64);
            transform: translateX(-50%);
          }
          &-title {
            font-weight: bold;
            font-size: use(36);
            color: #333333;
            margin-bottom: use(28);
          }
          &-desc {
            font-size: use(24);
            color: #9F7E61;
            text-align: center;
            line-height: use(40);
            margin-bottom: use(24);
          }
          &-remind {
            background-image: linear-gradient(141deg, #FFB500 0%, #F48F00 100%);
            border-radius: use(100);
            font-weight: bold;
            font-size: use(24);
            color: #FFFFFF;
            line-height: use(54);
            transform: translateY(50%);
            display: inline-block;
            margin: 0 auto;
            padding: 0 use(43);
          }
          &-bottom {
            padding: use(37) 0;
            background-color: #FFF4E8;
            h5 {
              font-size: use(24);
              color: #684423;
              text-align: center;
              line-height: use(40);
            }
            img {
              border-radius: use(8);
              border: use(4) solid #EFDAB9;
              width: use(186);
              margin: use(46) auto use(27);
            }
            p {
              font-weight: bold;
              font-size: use(24);
              color: #E9C7A3;
            }
          }
        }
      }
    }
    &-err {
      position: fixed;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      padding: use(42) use(40) use(32);
      background-color: rgba(#000000, 0.6);
      border-radius: use(10);
      text-align: center;
      img {
        width: use(78);
        margin: 0 auto use(18);
      }
      p {
        font-weight: bold;
        font-size: use(28);
        color: #FFFFFF;
        text-align: center;
        line-height: use(44);
      }
    }
    .grey {
      background: #aaa;
    }
  }
</style>
